import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { AdDataLayerConfig } from './types';
import { useAdBreakpoint } from './useAdBreakpoint';

const SITE_VERSION = '1.0.0';
const COMMERCIAL_SECTION = 'fantasy';
const CONTENT_TYPE = 'games';

/**
 * Writes the advertising data layer, pageViewId, and fullURL on every route change.
 * The analytics provider is the single owner of window.utag_data.
 * Must be rendered inside a React Router context (inside <BrowserRouter>).
 */
export function useAdDataLayer({
  blocked = false,
  commercialSection = COMMERCIAL_SECTION,
  cpn = '',
  tealiumId = 'NO_VALID_UUID',
  isLoggedIn = false,
}: Partial<AdDataLayerConfig> = {}) {
  const { pathname } = useLocation();
  const device = useAdBreakpoint();
  const pageViewIdRef = useRef<string>(crypto.randomUUID());

  useEffect(() => {
    pageViewIdRef.current = crypto.randomUUID();
  }, [pathname]);

  useEffect(() => {
    window.pageViewId = pageViewIdRef.current;
    window.fullURL = window.location.origin;

    window.nuk = {
      emailHash: '',
      ads: {
        blocked,
        commercialSection,
        cont: '',
        siteVersion: SITE_VERSION,
        tuples: {
          path: pathname,
          cont: CONTENT_TYPE,
          cpn,
          device,
          tealiumId,
          isLive: '0',
          fullPath: window.location.origin + pathname,
          bc: '0',
        },
      },
      user: {
        isLoggedIn: isLoggedIn ? 'true' : 'false',
        registrationType: '',
        customerType: isLoggedIn ? 'subscribed' : 'guest',
      },
    };
  }, [pathname, blocked, commercialSection, cpn, tealiumId, isLoggedIn, device]);
}
